import React, { useEffect, useState } from "react";
import { getInitialData } from "../../../service/apiFetch";
import { useRouter } from "next/router";
import { getQuizAllById } from "../../../service/apiFetch";
import Link from "next/link";

export const getStaticPaths = async () => {
  return {
    paths: [],
    fallback: "blocking",
  };
};

export const getStaticProps = async () => {
  try {
    const initialData = await getInitialData(`mock-test`, {
      getOnlyWebsiteData: true,
    });

    return {
      props: {
        websiteData: initialData?.websiteData || "",
        data: initialData?.data || { contentBlock: {} },
        title: initialData?.title || "",
        metaTags: initialData?.metaTags || "",
        url: initialData?.url || "",
      },
    };
  } catch (error) {
    console.error("API fetch failed:", error);
    return {
      props: {
        data: { contentBlock: {} },
      },
    };
  }
};

export default function Index() {
  const [data, setData] = useState();
  const [loading, setLoading] = useState(true);
  const router = useRouter();

  const fetchQuizlist = async () => {
    setLoading(true);
    try {
      const quizList = await getQuizAllById(router.query.id);
      setData(quizList);
    } catch (error) {
      console.error("Failed to fetch quiz data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (router.query.id) {
      fetchQuizlist();
    }
  }, [router.query.id]);

  return (
    <>

    <section className="min-h-[470px]">
      {loading ? (
        <div className="container py-8 animate-pulse">
          <div className="h-8 bg-gray-200 rounded w-32 mx-auto mb-6" />
          <div className="bg-gray-100 p-3 rounded flex gap-4 mb-2">
            <div className="h-4 bg-gray-300 rounded w-8" />
            <div className="h-4 bg-gray-300 rounded flex-1" />
            <div className="h-4 bg-gray-300 rounded w-20" />
            <div className="h-4 bg-gray-300 rounded w-20" />
            <div className="h-4 bg-gray-300 rounded w-24" />
          </div>
          {[1,2,3].map(i => (
            <div key={i} className="flex gap-4 py-3 border-b">
              <div className="h-4 bg-gray-200 rounded w-8" />
              <div className="h-4 bg-gray-200 rounded flex-1" />
              <div className="h-4 bg-gray-200 rounded w-20" />
              <div className="h-4 bg-gray-200 rounded w-20" />
              <div className="h-4 bg-gray-200 rounded w-24" />
            </div>
          ))}
        </div>
      ) : data?.length > 0 ? (
        <section>
          <div className="heading bg-color mt-4">
            <h2 className="text-center text-xl font-semibold py-1">
              Mock Test
            </h2>
          </div>

          <div className="container ">
            <div className="mt-6 py-4">
              <div className="overflow-x-auto">
                <table className="min-w-full text-left border border-gray-300">
                  <thead>
                    <tr className="bg-yellow-300">
                      <th className="px-4 py-1 border border-gray-300">#</th>
                      <th className="px-4 py-1 border border-gray-300">Title</th>
                      <th className="px-4 py-1 border border-gray-300">No. Of Ques</th>
                      <th className="px-4 py-1 border border-gray-300">Total Marks</th>
                      <th className="px-4 py-1 border border-gray-300">Access</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.map((item, ind) => (
                      <tr className="hover:bg-gray-100" key={ind}>
                        <td className="px-4 py-1 border border-gray-300 font-bold">{ind + 1}</td>
                        <td className="px-4 py-1 border border-gray-300">
                          <b>{item.qset.title}</b>
                          <br />
                          <small className="text-gray-600">
                            <i className="fa-regular fa-clock mr-1"></i>
                            {new Date(item.qset.createdAt).toLocaleString("en-US", {
                              day: "numeric",
                              month: "numeric",
                              year: "numeric",
                              hour: "numeric",
                              minute: "2-digit",
                              second: "2-digit",
                              hour12: true,
                            })}
                          </small>
                        </td>
                        <td className="px-4 py-1 border border-gray-300">{item.qset.totalQs}</td>
                        <td className="px-4 py-1 border border-gray-300">{item.qset.totalMarks}</td>
                        <td className="px-4 py-1 border border-gray-300">
                          <div className="flex items-center justify-center">
                            {new Date() > new Date(item.endDate) ? (
                              <span className="text-white bg-[#98c1d9] px-2 py-1 rounded-md text-sm cursor-not-allowed">
                                Expired
                              </span>
                            ) : (
                              <Link
                                href={`/quiz?quizId=${item.id}`}
                                // className="text-white bg-blue-800 px-2 text-sm py-1 rounded-md cursor-pointer"
                                className="my-button"
                              >
                                Attempt Now
                              </Link>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </section>
      ) : (
   <div className="flex flex-col items-center justify-center py-16 px-6 text-center">
      <img
        src="https://i.filecdn.in/807clcworld/notfoundquiezzesicon-1756963144456.png"
        alt="No quizzes"
        className="w-32 h-32 mb-6 opacity-80"
      />
      <h3 className="text-2xl font-semibold text-gray-700 mb-2">
        No Quizzes Available
      </h3>
      <p className="text-gray-500 max-w-md mb-6">
        Looks like there are no quizzes right now. Check back later or explore
        other categories to keep learning!
      </p>
      <Link
        href="/"
        className="my-button cursor-pointer"
      >
        Go to Home Page
      </Link>
    </div>
      )}

    </section>
    </>
  );
}
